import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../../styles/aboutUs-page/values/AboutUsValues.min.css';

const ValuesSection = () => {
    const values = [
        {
          image:  '/images/aboutUs-page/values/value1.svg',
      title: "Empoderamento Juvenil",
    },
        {
          image:  '/images/aboutUs-page/values/value2.svg',
      title: "Educação Transformadora",
    },
        {
          image:  '/images/aboutUs-page/values/value3.svg',
        
      title: "Inclusão e Diversidade",
        },
        {
          image:  '/images/aboutUs-page/values/value4.svg',
        
      title: "Cidadania Ativa",
        },
        {
            image: '/images/aboutUs-page/values/value5.svg',
        
            title: "Cooperação e Solidariedade",
        }
  ];
    return (
        <div className="about-us-values-section py-5 section-separator w-100 d-flex justify-content-center">
            <Container className='bg-transp m-0 justify-content-center w-100 d-flex flex-column'>
                <Row className='justify-content-center mb-4 bg-transp'>
                    <Col md={6} className='text-center bg-transp'>
                        <h2 className='display-5 fw-bold text-center bg-transp'>OS NOSSOS VALORES!</h2>
                    </Col>
                </Row>
                <Row className='bg-transp justify-content-center p-0 w-100 gap-3'>
                    {values.map((value, index) => (
                        <Col key={index} md={3} lg={2} className='text-center bg-transp'>
                            <img src={value.image} alt={value.title} className='about-us-value-icon bg-transp img-fluid' />
                            <p className='about-us-value-title fw-bold bg-transp fs-6 fs-md-4 mb-0 mt-2'>{value.title}</p>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default ValuesSection;